// import { useEffect, useRef } from 'react'
// import gsap from 'gsap'
// import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin'
// import DrawSVGPlugin from 'gsap/DrawSVGPlugin'
// import LogoV from '../../../assets/images/logo-new-v.svg'
import './index.scss'

const Logo = () => {
  // const bgRef = useRef()

  // const outlineLogoRef0 = useRef()
  // const outlineLogoRef1 = useRef()
  // const outlineLogoRef2 = useRef()
  // const outlineLogoRef3 = useRef()
  // const outlineLogoRef4 = useRef()
  // const outlineLogoRef5 = useRef()
  // const outlineLogoRef6 = useRef()
  // const outlineLogoRef7 = useRef()

  // const solidLogoRef = useRef()

  // useEffect(() => {
  //   gsap.registerPlugin(DrawSVGPlugin)

  //   //#0
  //   gsap
  //     .timeline()
  //     .to(bgRef.current, {
  //       duration: 1,
  //       opacity: 1,
  //     })

  //     .from(outlineLogoRef0.current, {
  //       drawSVG: 0,
  //       duration: 6,
  //     })
  //   //#1
  //   gsap
  //     .timeline()
  //     .to(bgRef.current, {
  //       duration: 1,
  //       opacity: 1,
  //     })

  //     .from(outlineLogoRef1.current, {
  //       drawSVG: 0,
  //       duration: 6,
  //     })
  //   //#2
  //   gsap
  //     .timeline()
  //     .to(bgRef.current, {
  //       duration: 1,
  //       opacity: 1,
  //     })

  //     .from(outlineLogoRef2.current, {
  //       drawSVG: 0,
  //       duration: 6,
  //     })
  //   //#3
  //   gsap
  //     .timeline()
  //     .to(bgRef.current, {
  //       duration: 1,
  //       opacity: 1,
  //     })

  //     .from(outlineLogoRef3.current, {
  //       drawSVG: 0,
  //       duration: 6,
  //     })
  //   //#4
  //   gsap
  //     .timeline()
  //     .to(bgRef.current, {
  //       duration: 1,
  //       opacity: 1,
  //     })

  //     .from(outlineLogoRef4.current, {
  //       drawSVG: 0,
  //       duration: 6,
  //     })
  //   //#5
  //   gsap
  //     .timeline()
  //     .to(bgRef.current, {
  //       duration: 1,
  //       opacity: 1,
  //     })

  //     .from(outlineLogoRef5.current, {
  //       drawSVG: 0,
  //       duration: 6,
  //     })

  //   //#6
  //   gsap
  //     .timeline()
  //     .to(bgRef.current, {
  //       duration: 1,
  //       opacity: 1,
  //     })

  //     .from(outlineLogoRef6.current, {
  //       drawSVG: 0,
  //       duration: 6,
  //     })
  //   //#7
  //   gsap
  //     .timeline()
  //     .to(bgRef.current, {
  //       duration: 1,
  //       opacity: 1,
  //     })

  //     .from(outlineLogoRef7.current, {
  //       drawSVG: 0,
  //       duration: 6,
  //     })

  //   gsap.fromTo(
  //     solidLogoRef.current,
  //     {
  //       opacity: 0,
  //     },
  //     {
  //       opacity: 1,
  //       delay: 4,
  //       duration: 4,
  //     }
  //   )
  // }, [])

  return (
    <div className="logo-container logo-char-for-telegram">
      {/* <img
        className="solid-logo"
        ref={solidLogoRef}
        src={LogoV}
        alt="JavaScript,  Developer"
      /> */}
      <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width="559pt"
        height="897pt"
        viewBox="0 0 559 897"
        // width="300.000000pt" height="300.000000pt" viewBox="0 0 300.000000 300.000000"
        preserveAspectRatio="xMidYMid meet"
      >
        <g
          className="svg-container"
          transform="translate(0 457) scale(.1 -.1)"
          fill="none"
        >
          {/* <g
          transform="translate(0.000000,300.000000) scale(0.100000,-0.100000)"
          fill="#ffd70a"
          stroke="none"
        > */}
          <path
            className="draw-logo"
            // ref={outlineLogoRef0}
            d="M1885 2685 c-16 -37 -24 -69 -20 -77 5 -7 4 -10 0 -5 -5 4 -28 -41 -52 -100 -38 -93 -52 -127 -71 -165 -2 -5 6 -8 16 -8 16 0 19 5 14 22 -4 16 -2 19 8 13 9 -5 11 -4 6 3 -4 7 -3 12 3 12 9 0 21 26 27 56 1 5 11 30 23 53 11 24 18 48 15 52 -3 5 -1 9 5 9 13 0 34 67 25 81 -4 8 -3 9 4 5 7 -4 12 -5 12 -2 0 3 9 28 20 55 15 40 16 50 5 54 -9 4 -22 -15 -40 -58z"
          />
          <path
            className="draw-logo"
            // ref={outlineLogoRef1}
            d="M1742 2308 c2 -5 8 -9 13 -9 5 0 11 4 13 9 1 5 -4 9 -13 9 -9 0 -14 -4 -13 -9z"
          />
          <path
            className="draw-logo"
            // ref={outlineLogoRef2}
            d="M1720 2281 c0 -5 7 -14 15 -21 16 -14 18 -10 9 14 -6 17 -24 22 -24 7z"
          />
          <path
            className="draw-logo"
            // ref={outlineLogoRef3}
            d="M1708 2248 c-4 -9 -2 -19 5 -22 7 -2 4 -5 -6 -5 -10 -1 -17 -7 -15 -13 1 -7 -3 -22 -9 -34 -7 -11 -32 -72 -58 -135 -25 -63 -50 -123 -55 -134 -20 -42 -109 -271 -115 -298 -4 -15 -10 -27 -14 -27 -3 0 -28 56 -55 125 -29 73 -53 122 -59 118 -6 -4 -8 0 -4 11 4 9 3 15 -2 12 -4 -3 -13 6 -20 20 -6 15 -7 23 -1 19 17 -10 12 4 -56 177 l-66 168 -133 0 -133 0 13 -27 c7 -16 36 -84 64 -153 93 -233 119 -293 131 -300 7 -4 9 -13 6 -19 -4 -6 -1 -14 7 -17 8 -3 13 -13 11 -22 -5 -21 120 -328 132 -325 16 4 16 33 0 33 -9 0 -16 8 -16 20 0 11 -4 20 -10 20 -5 0 -9 3 -8 8 4 17 -16 79 -38 114 -14 22 -20 40 -14 43 16 10 12 35 -5 35 -9 0 -15 6 -14 13 2 13 -14 60 -31 90 -7 12 -7 24 0 37 6 12 7 20 1 20 -5 0 -11 -6 -14 -12 -6 -18 -19 -3 -22 24 -4 38 -5 39 -14 34 -9 -6 -25 52 -25 91 0 12 -4 20 -8 17 -12 -7 -10 10 2 22 7 7 4 10 -11 10 -16 -1 -25 8 -35 37 -7 21 -9 37 -3 37 5 0 9 -5 9 -12 0 -6 3 -8 6 -5 4 4 1 14 -6 22 -11 13 -15 13 -21 3 -6 -9 -9 -6 -9 9 0 12 -4 24 -9 28 -6 3 -8 14 -6 25 2 12 0 18 -6 15 -5 -4 -9 1 -9 10 0 10 5 13 13 9 7 -4 9 -3 4 2 -5 5 -13 9 -19 9 -6 0 -14 10 -19 23 l-8 22 115 0 c115 0 115 0 109 -22 -7 -23 -7 -23 8 -3 15 19 16 19 13 -7 -2 -16 0 -28 4 -28 11 0 31 -51 24 -62 -4 -7 -2 -8 4 -4 7 4 12 3 12 -3 0 -5 -4 -12 -9 -15 -5 -3 -7 -15 -4 -26 5 -19 6 -20 19 -3 13 17 14 17 8 1 -4 -11 -1 -18 6 -18 10 0 10 -3 0 -15 -7 -8 -8 -15 -3 -15 5 0 8 -13 7 -29 -1 -20 2 -28 11 -25 8 3 15 -9 19 -37 4 -22 13 -54 21 -70 9 -16 15 -32 14 -35 0 -4 5 -10 12 -15 7 -4 13 -20 13 -36 1 -33 14 -56 27 -48 8 6 13 -10 12 -42 0 -6 5 -9 11 -7 6 2 11 -8 12 -27 1 -18 8 -36 18 -41 9 -5 13 -14 10 -20 -4 -7 -2 -8 4 -4 7 4 12 1 12 -9 0 -10 -5 -13 -12 -9 -8 5 -9 0 -6 -14 4 -12 2 -22 -2 -22 -11 0 -25 -40 -21 -64 2 -12 -1 -16 -9 -11 -9 5 -10 1 -5 -14 4 -12 2 -21 -4 -21 -6 0 -11 -7 -11 -15 0 -8 -4 -15 -10 -15 -5 0 -14 -9 -20 -20 -9 -16 -8 -18 5 -14 8 3 12 11 8 17 -3 6 -1 7 5 3 17 -10 16 -12 -24 -35 -19 -12 -32 -16 -29 -11 4 6 1 17 -5 25 -15 19 -37 21 -23 3 6 -7 18 -37 27 -65 10 -29 19 -53 21 -53 3 0 37 81 95 230 21 52 68 169 105 260 92 226 195 480 206 508 5 14 5 21 0 17 -5 -3 -11 3 -13 12 -3 17 -4 17 -10 1z"
          />
          <path
            className="draw-logo"
            // ref={outlineLogoRef4}
            d="M1837 2213 c-6 -21 -31 -83 -82 -208 -21 -49 -54 -133 -75 -185 -20 -52 -74 -187 -120 -299 -65 -162 -79 -205 -69 -212 22 -14 32 -10 26 11 -3 10 -1 20 4 22 5 2 11 14 14 27 2 14 10 28 16 32 6 4 12 18 12 32 0 16 6 27 17 30 17 4 20 32 6 55 -4 6 -3 12 3 12 5 0 12 14 16 30 4 17 11 30 16 30 6 0 7 5 4 10 -4 6 -11 7 -17 4 -7 -4 -8 -2 -4 4 4 6 14 8 23 5 10 -4 14 -2 9 5 -3 6 -2 13 3 16 5 3 7 19 6 35 -3 39 11 62 25 41 6 -9 10 -10 10 -3 0 6 -5 15 -10 18 -8 5 -7 12 2 22 6 8 13 22 14 30 5 29 14 44 24 38 5 -3 10 1 10 10 0 9 -4 13 -10 10 -6 -3 -7 1 -4 9 3 9 10 13 15 10 5 -3 6 2 3 10 -3 9 -2 16 4 16 5 0 10 6 9 13 -1 33 5 46 24 52 16 5 19 13 15 29 -3 13 -2 26 2 30 4 4 7 13 7 19 0 7 6 13 13 13 25 3 27 5 12 14 -13 9 -13 11 0 20 10 6 11 10 3 10 -7 0 -13 5 -13 11 0 5 5 7 10 4 6 -4 10 -3 9 2 -1 4 0 11 1 16 5 15 8 27 9 43 1 11 7 15 19 12 14 -4 18 1 17 21 l0 26 113 3 c89 2 113 0 110 -10 -3 -7 -10 -13 -15 -13 -16 0 -23 -9 -28 -34 -2 -14 0 -19 7 -15 7 5 8 2 2 -7 -5 -8 -9 -16 -10 -19 0 -3 -8 -21 -16 -40 -9 -19 -14 -39 -11 -44 4 -5 1 -6 -5 -2 -6 4 -8 14 -5 24 3 9 3 14 -1 10 -5 -4 -10 -24 -12 -45 -2 -21 -5 -43 -6 -50 -1 -7 -5 -10 -10 -7 -5 3 -6 11 -2 17 3 7 -2 3 -10 -7 -11 -14 -13 -23 -5 -32 14 -17 4 -45 -27 -79 -14 -15 -26 -36 -27 -46 -1 -11 -4 -19 -8 -19 -3 0 -5 -11 -4 -25 2 -14 -1 -25 -6 -25 -6 0 -22 -25 -36 -56 -14 -30 -36 -67 -49 -81 -15 -16 -22 -34 -19 -45 3 -10 7 -27 10 -37 4 -14 0 -21 -14 -26 -24 -7 -44 2 -36 16 4 5 1 9 -4 9 -30 0 3 -40 34 -41 19 0 19 -1 -2 -16 -22 -15 -34 -41 -13 -28 6 3 10 2 10 -4 0 -17 -18 -22 -24 -6 -9 24 -26 17 -26 -11 0 -19 4 -25 15 -20 13 4 14 2 5 -14 -6 -11 -8 -20 -4 -20 3 0 -5 -15 -20 -34 -14 -19 -26 -44 -26 -55 0 -12 -5 -21 -11 -21 -6 0 -9 -9 -6 -20 3 -11 0 -18 -7 -17 -6 1 -10 -9 -9 -26 1 -15 -2 -25 -8 -21 -5 3 -9 2 -8 -3 4 -23 -2 -35 -16 -29 -8 3 -15 1 -15 -4 0 -6 8 -10 18 -11 13 0 12 -2 -5 -9 -13 -5 -23 -12 -23 -15 0 -4 5 -3 10 0 6 3 10 1 10 -4 0 -6 -4 -11 -10 -11 -5 0 -10 -10 -10 -22 0 -12 -8 -30 -17 -40 -9 -10 -17 -26 -18 -36 -1 -9 -8 -30 -15 -47 -7 -16 -14 -36 -16 -43 -6 -29 -13 -40 -26 -38 -24 3 -38 17 -38 37 0 10 -5 19 -11 19 -6 0 -9 -3 -7 -7 2 -5 14 -36 27 -71 l24 -63 59 141 c32 78 55 146 52 152 -4 6 -3 8 3 5 6 -4 13 1 16 11 3 9 23 60 45 112 164 394 159 380 138 380 -10 0 -13 6 -9 16 3 8 11 13 19 10 17 -7 33 14 40 55 4 19 12 41 19 49 12 15 66 139 128 290 19 47 49 118 65 158 l31 72 -133 0 c-119 0 -134 -2 -139 -17z"
          />
          <path
            className="draw-logo"
            // ref={outlineLogoRef5}
            d="M1460 1266 c-8 -17 -13 -35 -12 -40 2 -5 -3 -13 -10 -18 -10 -6 -10 -10 2 -18 13 -9 7 -14 -12 -11 -5 0 -8 -8 -8 -18 0 -11 -4 -21 -9 -23 -14 -5 -83 -187 -75 -200 4 -6 3 -8 -3 -5 -9 6 -217 -494 -217 -525 0 -9 -3 -15 -7 -12 -11 6 -22 -34 -13 -47 4 -7 3 -9 -3 -6 -6 4 -14 0 -17 -9 -9 -23 -8 -24 12 -24 20 0 57 84 45 103 -3 6 -1 7 5 3 11 -7 16 7 15 41 -1 7 2 11 6 9 4 -3 58 123 121 280 102 254 130 312 130 272 0 -9 3 -9 9 1 5 8 6 24 1 36 -9 24 -2 77 10 70 4 -3 10 3 14 13 3 9 12 35 21 57 9 22 18 49 20 59 3 11 10 23 16 26 7 5 4 9 -8 12 -14 4 -23 -3 -33 -26z"
          />
          <path
            className="draw-logo"
            // ref={outlineLogoRef6}
            d="M1497 1223 c-11 -11 -8 -33 5 -33 6 0 8 3 5 7 -4 3 -2 12 4 20 11 13 -2 19 -14 6z"
          />
          <path
            className="draw-logo"
            // ref={outlineLogoRef7}
            d="M1437 1007 c-15 -10 -16 -17 -6 -45 6 -17 15 -32 19 -32 16 0 21 20 10 37 -9 15 -10 14 -5 -7 5 -22 5 -23 -6 -6 -8 13 -8 25 0 42 12 28 11 29 -12 11z"
          />
        </g>
      </svg>
      ;
    </div>
  )
}

export default Logo
